import {Component, OnInit} from '@angular/core';

import { UserService } from '../user/user.service';
import { HeaderService } from './header.service';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {TrialService} from '../trial/trial.service';
import {ConfigService} from '../main/config/config.service';
import {Subscription} from 'rxjs/Rx';
import {SystemInformationService} from '../systeminformation/systeminformation.service';

@Component({
    selector: 'header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss',
        '../../../node_modules/bootstrap/dist/css/bootstrap.css']
})
export class HeaderComponent implements OnInit{

    trialStatusSubscription: Subscription;
    trialMode: boolean = false;
    trialModeExpired: boolean = false;
    trialData: string;
    trialMax: any;
    consume: any = 0;
    threshold: any = 0;

    showDevDurations: boolean = true;

    currentRoute: string = '/';
    private currentAttackSubscription: Subscription;

    constructor(private router: Router,
                private route: ActivatedRoute,
                private userService: UserService,
                private headerService: HeaderService,
                private trialService: TrialService,
                private cfgService: ConfigService,
                private systemInformationService: SystemInformationService) {
        this.router.events.subscribe(
            (event) => {
            if (event instanceof NavigationEnd ) {
                this.currentRoute = event.url;
            }
        });


    }

    ngOnInit() {

        var me = this;


        this.systemInformationService.getSystemInformation().subscribe(information => {
            if(information['ShowDevDurations'] != null){
                this.showDevDurations = information['ShowDevDurations']
            }
        });
        //Only do these things if user is in trialMode
      //  if (this.userService.getCurrentUser()['TrialMode']) {

        this.trialStatusSubscription = this.trialService.trialStatusChanged
            .subscribe(
                (response) =>{
                    if(response.trialMode){
                        this.trialMode = response.trialMode;
                        this.trialModeExpired = response.trialModeExpired;
                        this.trialData = response.trialData;
                        this.trialMax = response.max;

                        if(this.trialMode && this.trialMax === 0){
                            this.navigate('trial');
                        }
                    }else{
                        this.trialMode = response.trialMode;
                        this.consume = response.consume;
                        this.threshold = response.threshold;

                    }

                }
            );

        this.trialService.getAccountStatus(this.userService.getCurrentUser().Email);

     //   }

        this.currentAttackSubscription = this.cfgService.currentAttackSubject
            .subscribe(
                (attack) => {
                    if(/*me.trialMode && */attack && attack.Status && (attack.Status === 'Stopped' || attack.Status === 'Failed')){
                        this.trialService.getAccountStatus(this.userService.getCurrentUser().Email);
                    }});

    }

    logOut() {
        this.userService.logOut();
    }

    isLoggedIn(): boolean {
        return this.userService.isLoggedIn();
    }

    navigateHome() {
        this.headerService.navigateHome();
    }


    navigate( value:string ) {
        this.headerService.navigate(value);
    }

    buyNowClick() {
        if(this.showDevDurations) {
            window.location.href = 'https://store-uat.ixiacom.com/product/BreakingPoint-Cloud';
        } else {
            window.location.href = 'https://www.ixiacom.com/products/breakingpoint-cloud';
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/headerfooter/header.component.ts